import React from 'react';
import { withRouter } from 'react-router-dom';

import { Routes } from '../helpers/_routes';
import AppContext from '../services/Context';
import styled from '../styled-components';
import PageTitle from './PageTitle';

const getRouteName = (path: string) => {
    for (const key in Routes) {
        if (Routes.hasOwnProperty(key)) {            
            const route = Routes[key];     

            // Spliting path to remove content after path second '/'
            if (path !== "/") {
                var pathRoute = path.split('/');
                path = "/" + pathRoute[1];
            }

            if (path === route) return key;
        }
    }

    return '';
};

export default withRouter(
    ({ children, location }: { children?: React.ReactNode; location: { pathname: string, state: string } }) => (
        <AppContext.Consumer>
            {({ theme, authorized }) => {
                return (
                    <Wrapper theme={theme}>
                        <PageTitle page={getRouteName(location.pathname)} />
                        {children}
                    </Wrapper>
                )
            }}
        </AppContext.Consumer>
    ),
);

const Wrapper = styled.div`
  flex: 1;
  padding: 40px 50px;
  margin-left: ${({ theme }) => theme.sidebarSize || '150px'};
  margin-top: ${({ theme }) => theme.headerHeight || '150px'};
  max-width:100%;
  width: 100%;
  overflow: auto;
`;
